export const SOFTLINE_API_OFFENE_POSTEN = '/v1/einzugsuebersicht/entities';
export const SOFTLINE_API_JOPOSTEN = '/v1/joposten/entities';
export const SOFTLINE_API_JOPOSTEN_BELEG_DOWNLOAD = '/v1/joposten/entities/{{idjoposten}}/export/beleg';
